var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorLayout',[_c('p',[_vm._v("ベネフィット・ステーションは契約対象外のためご利用いただけません。")]),_c('p',[_vm._v("利用対象サービスをご所属団体のご担当者様へご確認ください。")]),_c('p',[_vm._v("他サービスのログイン画面は下記をご確認ください。")]),_c('a',{attrs:{"href":_vm.bsLoginURL}},[_vm._v(_vm._s(_vm.bsLoginURL))])])
}
var staticRenderFns = []

export { render, staticRenderFns }